var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportingDocumentMobTabIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7909",
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29891",
    "data-name": "Group 29891",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27920",
    "data-name": "Group 27920"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_7909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7909-2",
    "data-name": "Rectangle 7909",
    width: 27,
    height: 27,
    rx: 3,
    transform: "translate(9 6)",
    fill: "#EB1700"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "description_black_24dp",
    transform: "translate(2.838 2.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17541",
    "data-name": "Path 17541",
    d: "M0,0H21.323V21.323H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17542",
    "data-name": "Path 17542",
    d: "M7.554,14.439h7.108v1.777H7.554Zm0-3.554h7.108v1.777H7.554ZM12.885,2H5.777A1.782,1.782,0,0,0,4,3.777V17.992a1.775,1.775,0,0,0,1.768,1.777H16.439a1.782,1.782,0,0,0,1.777-1.777V7.331Zm3.554,15.992H5.777V3.777H12V8.219h4.442Z",
    transform: "translate(-0.446 -0.223)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportingDocumentMobTabIcon);
export default __webpack_public_path__ + "static/media/supportingDocument-mob-tab-icon.8aa2b8ace31dda141fe66df238d153e9.svg";
export { ForwardRef as ReactComponent };